var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIconGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2431 10.4805C23.2431 11.1836 22.6572 11.7344 21.9931 11.7344H20.7431L20.7705 17.9922C20.7705 18.0977 20.7627 18.2031 20.751 18.3086V18.9375C20.751 19.8008 20.0517 20.5 19.1885 20.5H18.5635C18.5205 20.5 18.4775 20.5 18.4346 20.4961C18.3799 20.5 18.3252 20.5 18.2705 20.5H17.001H16.0635C15.2002 20.5 14.501 19.8008 14.501 18.9375V18V15.5C14.501 14.8086 13.9424 14.25 13.251 14.25H10.751C10.0596 14.25 9.50096 14.8086 9.50096 15.5V18V18.9375C9.50096 19.8008 8.80174 20.5 7.93846 20.5H7.00096H5.75487C5.69627 20.5 5.63768 20.4961 5.57909 20.4922C5.53221 20.4961 5.48534 20.5 5.43846 20.5H4.81346C3.95018 20.5 3.25096 19.8008 3.25096 18.9375V14.5625C3.25096 14.5273 3.25096 14.4883 3.25487 14.4531V11.7344H2.00096C1.29784 11.7344 0.750961 11.1875 0.750961 10.4805C0.750961 10.1289 0.868149 9.81641 1.14159 9.54297L11.1572 0.8125C11.4306 0.539062 11.7431 0.5 12.0166 0.5C12.29 0.5 12.6025 0.578125 12.8369 0.773438L22.8135 9.54297C23.126 9.81641 23.2822 10.1289 23.2431 10.4805Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIconGrey);
export default __webpack_public_path__ + "static/media/home_icon_grey.d7cc575a07600137daa429a45370fbd2.svg";
export { ForwardRef as ReactComponent };